export const FINANCIAL_ADVICE_DISCLAIMER =
  "CRAM Finance is an educational and informational platform only. We are not financial advisors, brokers, or fiduciaries. All data, interest rates, and product representations are provided for illustrative purposes and do not constitute financial, investment, or legal advice. Past performance does not guarantee future results. Users should consult with a licensed professional before making any financial decisions.";

export default function DisclaimerNotice({ compact = false }) {
  return (
    <div
      data-testid="financial-advice-disclaimer"
      role="note"
      aria-label="Financial disclaimer"
      style={{
        margin: compact ? "0 0 18px" : "0 auto 24px",
        padding: compact ? "14px 16px" : "18px 20px",
        border: "1px solid rgba(211, 175, 86, 0.28)",
        borderRadius: 16,
        background: compact ? "rgba(255, 255, 255, 0.04)" : "rgba(211, 175, 86, 0.08)",
        boxShadow: compact ? "none" : "0 10px 30px rgba(0, 0, 0, 0.1)",
        maxWidth: compact ? "100%" : 980,
      }}
    >
      <strong
        style={{
          display: "block",
          marginBottom: compact ? 4 : 8,
          color: compact ? "var(--gold)" : "var(--t-on-dark)",
          fontSize: compact ? 12 : 13,
          letterSpacing: "0.16em",
          textTransform: "uppercase",
        }}
      >
        Mandatory Not Financial Advice Disclaimer
      </strong>
      <p
        style={{
          margin: 0,
          color: compact ? "var(--t-on-dark-2)" : "var(--ink-deep)",
          fontSize: compact ? 12 : 14,
          lineHeight: 1.65,
        }}
      >
        {FINANCIAL_ADVICE_DISCLAIMER}
      </p>
    </div>
  );
}
